export class MenuConfig {
	public defaults: any = {
		header: {
			self: {},
			items: [
				{
					title: "Dashboards",
					root: true,
					alignment: "left",
					page: "/dashboard",
					translate: "MENU.DASHBOARD",
					pageCode: "DH",
				},
				// {
				// 	title: 'My Profile',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/profile',
				// 	role: 'USER'
				// },
				{
					title: "Degree Attestation",
					root: true,
					alignment: "left",
					page: "/das-app",
					icon: "fas fa-book-open",
					translate: "MENU.DEGREE_ATTESTATION",
					pageCode: "DA",
				},
				{
					title: "Update Authorized Person Details",
					root: true,
					alignment: "left",
					page: "/authorize-person",
					icon: "far fa-user",
					pageCode: "UA",
				},
				{
					title: "Foreign Embassy Admin Screen",
					root: true,
					alignment: "left",
					page: "/foreign-embassy",
					icon: "far fa-user",
					view: "FOREIGN",
					pageCode: "FE",
				},
				{
					title: "Track Applications",
					root: true,
					alignment: "left",
					page: "/track-application",
					icon: "far fa-list-alt",
					translate: "MENU.TRACK_APPLICATIONS",
					pageCode: "TA",
				},
				// {
				// 	title: 'Degree Equivalence',
				// 	root: true,
				// 	alignment: 'left',
				// 	role: 'USER',
				// 	submenu: [
				// 		{
				// 			title: 'Local Degree Equivalence',
				// 			alignment: 'left',
				// 			page: '/localdes',
				// 			role: 'USER'
				// 		},
				// 		{
				// 			title: 'Foreign Degree Equivalence',
				// 			alignment: 'left',
				// 			page: '/foreigndes',
				// 			role: 'USER'
				// 		},
				// 		{
				// 			title: 'Madarsa Degree Equivalence',
				// 			alignment: 'left',
				// 			page: '/madarsades',
				// 			role: 'USER'
				// 		}
				// 	]
				// },
				{
					title: "DES Admin Options",
					root: true,
					alignment: "left",
					role: "DES",
					submenu: [
						{
							title: "Admin Dashboard",
							root: true,
							alignment: "left",
							page: "/admin-dashboard",
							icon: "far fa-user",
							pageCode: "AD",
							screenRole: "TA",
							role: "DES",
						},
						{
							title: "Application List",
							root: true,
							alignment: "left",
							page: "/des-admin/tasks",
							role: "DES",
							screenRole: "TA",
							pageCode: "AL",
						},
						{
							title: "Admin Verification",
							root: true,
							alignment: "left",
							page: "/des-verification",
							icon: "far fa-user",
							pageCode: "AV",
							screenRole: "GLOBAL",
							role: "DES",
						},
						// {
						// 	title: 'Admin Reporting',
						// 	root: true,
						// 	alignment: 'left',
						// 	page: '/des-reporting',
						// 	icon: 'far fa-user',
						// 	pageCode:'AR',
						// 	role: 'ADMIN'

						// },
					],
				},
			// {
			// 	title: "DAS Admin Options",
			// 	root: true,
			// 	alignment: "left",
			// 	role: "DAS",
			// 	submenu: [
			// 		{
			// 			title: "Application Processing",
			// 			root: true,
			// 			alignment: "left",
			// 			page: "/das-admin/application-processing",
			// 			icon: "far fa-user",
			// 			pageCode: "AP",
			// 			role: "DAS",
			// 			allwoed: false,
			// 		},
			// 	],
			// },
			],
		},
		aside: {
			self: {},
			items: [
				{
					title: "Dashboard",
					root: true,
					icon: "fas fa-home",
					page: "/dashboard",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					allwoed: true,
					pageCode: "DH",
				},
				// {
				// 	title: 'My Profile',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/profile',
				// 	icon: 'far fa-user',
				// 	role: 'USER'
				// },
				{
					title: "Degree Attestation",
					root: true,
					alignment: "left",
					page: "/das-app",
					icon: "fas fa-book-open",
					translate: "MENU.DEGREE_ATTESTATION",
					allwoed: true,
					pageCode: "DA",
				},
				{
					title: "Update Authorized Person Details",
					root: true,
					alignment: "left",
					page: "/authorize-person",
					icon: "fas fa-chalkboard-teacher",
					allwoed: false,
					pageCode: "UA",
				},
				{
					title: "Foreign Embassy Verification",
					root: true,
					data: true,
					alignment: "left",
					page: "/degree-verification-services/main",
					icon: "fab fa-elementor",
					allwoed: false,
					view: "FOREIGN",
					pageCode: "FE",
					screenRole: "EAD", //Equivalence Admin (AD DD)
					// submenu: [
					// 	{
					// 		title: "Degree Attestation Verfication",
					// 		alignment: "left",
					// 		page: "/foreign-embassy",
					// 		role: "USER",
					// 		allwoed: true,
					// 	},
					// 	{
					// 		title: "Local Degree Equivalence Verification",
					// 		alignment: "left",
					// 		page: "/foreign-embassy/local-equivalence",
					// 		role: "USER",
					// 		allwoed: true,
					// 	},
					// 	{
					// 		title: "Foreign Degree Equivalence Verification",
					// 		alignment: "left",
					// 		page: "/foreign-embassy/foreign-equivalence",
					// 		role: "USER",
					// 		allwoed: true,
					// 	},
					// ]
				},
				// {
				// 	title: "DAS Admin Scheduler",
				// 	root: true,
				// 	alignment: "left",
				// 	page: "/scheduler",
				// 	icon: "fas fa-shipping-fast",
				// 	translate: "DAS Admin Scheduler",
				// 	allwoed: false,
				// 	pageCode: "SCH",
				// 	role: "DAS",
				// },
				{
					title: "DAS-Scrutiny",
					root: true,
					alignment: "left",
					page: "/hec-scrutiny/dashboard",
					icon: "fas fa-search",
					translate: "DAS-Scrutiny",
					allwoed: false,
					pageCode: "DSS",
					role: "DAS",
				},
				{
					title: "Attestation Education Correction",
					root: true,
					alignment: "left",
					page: "/hec-scrutiny/attestation-education-correction",
					icon: "fas fa-user-graduate",
					translate: "Attestation Education Correction",
					allwoed: false,
					pageCode: "DEC",
					role: "DAS",
				},
				{
					title: "Approved Blacklisted Applicants",
					root: true,
					alignment: "left",
					page: "/approved-attestation-applicants",
					icon: "fas fa-list-alt",
					translate: "DAS Approved Blacklisted Applicants",
					allwoed: false,
					pageCode: "DABA",
					role: "DAS",
				},

				{
					title: "Track Applications",
					root: true,
					alignment: "left",
					page: "/track-application",
					icon: "fas fa-list-alt",
					translate: "MENU.TRACK_APPLICATIONS",
					allwoed: true,
					pageCode: "TA",
				},
				// {
				// 	title: "TCS Option",
				// 	root: true,
				// 	alignment: "left",
				// 	page: "/tcs",
				// 	icon: "fas fa-shipping-fast",
				// 	translate: "TCS Option",
				// 	allwoed: false,
				// 	pageCode: "TCS",
				// 	role: "DAS",
				// },
				{
					title: "Equivalence Services",
					root: true,
					alignment: "left",
					icon: "fas fa-align-center",
					allwoed: true,
					submenu: [
						{
							title: "Local Degree Recognition",
							alignment: "left",
							page: "/localdes",
							role: "USER",
							allwoed: true,
						},
						{
							title: "Foreign Degree Recognition/Equivalence",
							alignment: "left",
							page: "/foreigndes",
							role: "USER",
							allwoed: true,
						},
						// 		// {
						// 		// 	title: 'Madarsa Degree Equivalence',
						// 		// 	alignment: 'left',
						// 		// 	page: '/madarsades',
						// 		// 	role: 'USER',
						// 		// 	allwoed:true,
						// 		// },
					],
				},
				//coursera active route disabled on 30th January 2023

				//coursera active route disabled on 6th April 2023
				{
					title: "Ecourses",
					root: true,
					alignment: "left",
					page: "/ecourses",
					icon: "fas fa-book",
					translate: "Ecourses",
					allwoed: true,
					pageCode: "EC",
				},
				{
					title: "PCD Admin",
					root: true,
					alignment: "left",
					icon: "fas fa-folder-open",
					allwoed: false,
					role: "PCD",
					pageCode: "PCDA",
					submenu: [

						{
							title: "PCD Admin",
							alignment: "left",
							page: "/pcd-admin",
							allwoed: true,
							role: "PCD",
						},
						{
							title: "PCD Admin Webpage",
							alignment: "left",
							page: "/pcd-admin/webpage",
							allwoed: true,
							role: "PCD",
						}
					],
				},
				// {
				// 	title: "PCD Admin",
				// 	root: true,
				// 	alignment: "left",
				// 	page: "/pcd-admin",
				// 	icon: "fas fa-folder-open",
				// 	translate: "PCD Admin",
				// 	allwoed: false,
				// 	role: "PCD",
				// 	pageCode: "PCDA",
				// },

				{
					title: "PCD University Focal Person",
					root: true,
					alignment: "left",
					page: "/controller",
					icon: "fas fa-folder-open",
					translate: "PCD University Focal Person",
					allwoed: false,
					role: "PCD",
					pageCode: "PCDC",
				},
				{
					title: "Ph.D. Country Directory",
					root: true,
					alignment: "left",
					page: "/pcd",
					icon: "fas fa-folder",
					translate: "Ph.D Country Directory",
					allwoed: true,
					pageCode: "PCD",
				},
				{
					title: "University Focal Person",
					root: true,
					alignment: "left",
					page: "/coursera-admin",
					icon: "fas fa-user",
					translate: "University Focal Person",
					allwoed: false,
					role: "COURSERA",
					pageCode: "ECA",
				},

			{
				title: "Stamp Details",
				root: true,
				alignment: "left",
				icon: "fas fa-user",
				translate: "Stamp Details",
				allwoed: false,
				role: "DAS",
				pageCode: "STD",
				submenu: [
					{
						title: "Stamp Generate",
						root: true,
						alignment: "left",
						page: "/stamp-details",
						icon: "fas fa-stamp",
						translate: "Stamp Generate",
						pageCode: "STG",
						role: "DAS",
						allwoed: false,
					},
					{
						title: "Stamp Stock",
						root: true,
						alignment: "left",
						page: "/stamp-stock",
						icon: "fas fa-boxes",
						translate: "Stamp Stock",
						pageCode: "STS",
						role: "DAS",
						allwoed: false,
					},
					{
						title: "Stamp Activate",
						root: true,
						alignment: "left",
						page: "/stamp-activate",
						icon: "fas fa-check-circle",
						translate: "Stamp Activate",
						pageCode: "STA",
						role: "DAS",
						allwoed: false,
					},
				],
			},
				

				{
					title: "DES Admin Options",
					root: true,
					pageCode: "AO",
					alignment: "left",
					icon: "fas fa-user-shield",
					allwoed: false,
					role: "DES",
					submenu: [
						{
							title: "Admin Dashboard",
							root: true,
							alignment: "left",
							page: "/admin-dashboard",
							icon: "fas fa-chart-line",
							allwoed: false,
							screenRole: "TA",
							pageCode: "AD",
							role: "DES",
						},

						{
							title: "Application List",
							root: true,
							alignment: "left",
							page: "/des-admin/tasks",
							icon: "fas fa-clipboard-list",
							role: "DES",
							allwoed: false,
							screenRole: "TA",
							pageCode: "AL",
						},
						{
							title: "DES Approve Blacklisted Applicants",
							root: true,
							alignment: "left",
							page: "/approved-des-applicants",
							icon: "fas fa-list-alt",
							translate: "DES Approve Blacklisted Applicants",
							allwoed: false,
							screenRole: "AD",
							pageCode: "AD",
							role: "DES",
						},
						{
							title: "Application Tracking",
							root: true,
							alignment: "left",
							page: "/des-tracking",
							icon: "fas fa-chart-line",
							allwoed: false,
							screenRole: "TA",
							pageCode: "AD",
							role: "DES",
						},
						{
							title: "Admin Verification",
							root: true,
							alignment: "left",
							page: "/des-verification",
							icon: "fas fa-certificate",
							allwoed: false,
							pageCode: "AV",
							screenRole: "GLOBAL",
							role: "DES",
						},
						{
							title: "Edit Templates",
							root: true,
							alignment: "left",
							page: "/des-templates",
							icon: "fas fa-certificate",
							allwoed: false,
							pageCode: "ET",
							screenRole: "GLOBAL",
							role: "DES",
						},
						{
							title: "Add Templates",
							root: true,
							alignment: "left",
							page: "/add-template",
							icon: "fas fa-plus-circle",
							allwoed: false,
							pageCode: "ET",
							screenRole: "GLOBAL",
							role: "DES",
						},
						{
							title: "Final Letter",
							root: true,
							alignment: "left",
							page: "/des-final-letter",
							icon: "fas fa-chart-line",
							allwoed: false,
							pageCode: "DFL",
							screenRole: "DFL",
							role: "DES",
						},
						// {
						// 	title: 'Admin Team Management',
						// 	root: true,
						// 	alignment: 'left',
						// 	page: '/des-teams',
						// 	icon: 'far fa-file',
						// 	allwoed:true,
						// 	pageCode:'AR',
						// 	role: 'DES'

						// },
					],
				},
				{
					title: "DESF Admin Options",
					root: true,
					pageCode: "AO",
					alignment: "left",
					icon: "fas fa-user-shield",
					allwoed: false,
					role: "DESF",
					submenu: [
						{
							title: "Admin Dashboard",
							root: true,
							alignment: "left",
							page: "/admin-dashboard",
							icon: "fas fa-chart-line",
							allwoed: true,
							pageCode: "AD",
							role: "DESF",
						},
						{
							title: "Application Tracking",
							root: true,
							alignment: "left",
							page: "/desf-tracking",
							icon: "fas fa-chart-line",
							allwoed: true,
							pageCode: "AD",
							role: "DESF",
						},
						{
							title: "Application List",
							root: true,
							alignment: "left",
							page: "/des-admin/tasks",
							icon: "fas fa-clipboard-list",
							role: "DESF",
							allwoed: true,
							pageCode: "AL",
						},
						{
							title: "Admin Verification",
							root: true,
							alignment: "left",
							page: "/desf-verification",
							icon: "fas fa-certificate",
							allwoed: false,
							pageCode: "AV",
							role: "DESF",
							screenRole: "GLOBAL",
						},

						{
							title: "DESF Approve Blacklisted Applicants",
							root: true,
							alignment: "left",
							page: "/approved-desf-applicants",
							icon: "fas fa-list-alt",
							translate: "DESF Approve Blacklisted Applicants",
							allwoed: false,
							screenRole: "AD",
							pageCode: "AD",
							role: "DESF",
						},

						// {
						// 	title: 'Admin Reporting',
						// 	root: true,
						// 	alignment: 'left',
						// 	page: '/des-reporting',
						// 	icon: 'far fa-file',
						// 	allwoed:true,
						// 	pageCode:'AR',
						// 	role: 'DESF'

						// },
						// {
						// 	title: 'Edit Templates',
						// 	root: true,
						// 	alignment: 'left',
						// 	page: '/des-templates',
						// 	icon: 'fas fa-certificate',
						// 	allwoed:true,
						// 	pageCode:'AV',
						// 	role: 'DESF'

						// },
						{
							title: "Final Letter",
							root: true,
							alignment: "left",
							page: "/desf-letter",
							icon: "fas fa-chart-line",
							allwoed: false,
							pageCode: "ADF",
							role: "DESF",
						},

						{
							title: "Third Final Letter",
							root: true,
							alignment: "left",
							page: "/desf-third-letter",
							icon: "fas fa-chart-line",
							allwoed: false,
							pageCode: "ADF",
							role: "DESF",
						},
						{
							title: "Third Letter Request",
							root: true,
							alignment: "left",
							page: "/desf-third-letter-request",
							icon: "fas fa-chart-line",
							allwoed: false,
							pageCode: "STL",
							role: "DESF",
						},
						// {
						// 	title: 'Admin Team Management',
						// 	root: true,
						// 	alignment: 'left',
						// 	page: '/des-teams',
						// 	icon: 'far fa-file',
						// 	allwoed:true,
						// 	pageCode:'AR',
						// 	role: 'DES'

						// },
					],
				},

				{
					title: "DES/DESF Admin Options",
					root: true,
					pageCode: "AO",
					alignment: "left",
					icon: "fas fa-user-shield",
					allwoed: false,
					role: "ALL",
					submenu: [
						{
							title: "Admin Dashboard",
							root: true,
							alignment: "left",
							page: "/admin-dashboard",
							icon: "fas fa-chart-line",
							allwoed: false,
							screenRole: "TA",
							pageCode: "AD",
							role: "DES",
						},

						{
							title: "Application List",
							root: true,
							alignment: "left",
							page: "/des-admin/tasks",
							icon: "fas fa-clipboard-list",
							role: "DESF",
							allwoed: false,
							screenRole: "TA",
							pageCode: "AL",
						},
						{
							title: "DES Application Tracking",
							root: true,
							alignment: "left",
							page: "/des-tracking",
							icon: "fas fa-chart-line",
							allwoed: false,
							screenRole: "TA",
							pageCode: "AD",
							role: "DES",
						},
						{
							title: "DESF Application Tracking",
							root: true,
							alignment: "left",
							page: "/desf-tracking",
							icon: "fas fa-chart-line",
							allwoed: true,
							pageCode: "AD",
							role: "DESF",
						},
						{
							title: "DES Admin Verification",
							root: true,
							alignment: "left",
							page: "/des-verification",
							icon: "fas fa-certificate",
							allwoed: false,
							pageCode: "AV",
							screenRole: "GLOBAL",
							role: "DES",
						},
						{
							title: "DESF Admin Verification",
							root: true,
							alignment: "left",
							page: "/desf-verification",
							icon: "fas fa-certificate",
							allwoed: false,
							pageCode: "AV",
							screenRole: "GLOBAL",
							role: "DES",
						},
						{
							title: "DES Edit Templates",
							root: true,
							alignment: "left",
							page: "/des-templates",
							icon: "fas fa-certificate",
							allwoed: false,
							pageCode: "ET",
							screenRole: "GLOBAL",
							role: "DES",
						},
						{
							title: "DESF Final Letter",
							root: true,
							alignment: "left",
							page: "/desf-letter",
							icon: "fas fa-chart-line",
							allwoed: false,
							pageCode: "ADF",
							role: "DESF",
						},
						{
							title: "Third Final Letter",
							root: true,
							alignment: "left",
							page: "/desf-third-letter",
							icon: "fas fa-chart-line",
							allwoed: false,
							pageCode: "ADF",
							role: "DESF",
						},
						// {
						// 	title: 'Admin Team Management',
						// 	root: true,
						// 	alignment: 'left',
						// 	page: '/des-teams',
						// 	icon: 'far fa-file',
						// 	allwoed:true,
						// 	pageCode:'AR',
						// 	role: 'DES'

						// },
					],
				},

				// {
				// 	title: "DAS Admin Options",
				// 	root: true,
				// 	pageCode: "DAO",
				// 	alignment: "left",
				// 	icon: "fas fa-user-shield",
				// 	allwoed: false,
				// 	role: "DAS",
				// 	submenu: [
				// 		{
				// 			title: "Application Processing",
				// 			root: true,
				// 			alignment: "left",
				// 			page: "/das-admin/application-processing",
				// 			icon: "fas fa-chart-line",
				// 			allwoed: true,
				// 			pageCode: "AP",
				// 			role: "DAS",
				// 		},
				// 	],
				// },
			],
		},
	};

	public get configs(): any {
		return this.defaults;
	}
}
